import { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "What is the Minimum Order Quantity (MOQ)?",
    a:
      "All qualities are sold in Thans (fold cuts) — 20 metres per than for small panna qualities (600 Lining, 600 Gold, 060, 006, 303 Pure Cotton) and 24 metres per than for big panna qualities and American Crepe (6000 Shrinkless, Super Queen, 3000 Pure Cotton, American Crepe). There is no minimum than count — a single than of any shade is enough to place an order. 600 Gold is also available as cut pieces, sold as an assorted 50-colour pack in 100 cm or 80 cm lengths.",
  },
  {
    q: "What payment methods do you accept?",
    a:
      "We accept Cash, Card, UPI, NEFT, RTGS and IMPS. Bank details and UPI ID are shared over WhatsApp once you confirm the shade list. Payment confirmation is required before dispatch for out-of-Bangalore orders.",
  },
  {
    q: "Do I need to provide GST details?",
    a:
      "GST registration is preferred for all orders and mandatory for purchases above ₹50,000 (so we can raise a compliant tax invoice). If you don't have a GST number, a government-registered ID card (Aadhaar / PAN / Voter ID / Driving Licence) is sufficient for smaller orders.",
  },
  {
    q: "How does delivery work?",
    a:
      "Same-day delivery inside Bangalore, 3–4 days for South India, 5–7 days pan-India via VRL Logistics, and 7–14 days international via FedEx/DHL. Free delivery in Bangalore for orders above ₹50,000. See the Delivery page for full details.",
  },
  {
    q: "What is the return / exchange policy?",
    a:
      "Manufacturing defects are exchanged within 7 days of receipt if the fabric is unused and returned in original packaging. Custom-dyed shades, cut fabric and lots that have been washed/dyed further cannot be returned. Full policy is on the Exchange Policy page.",
  },
  {
    q: "Can I match a specific shade?",
    a:
      "Yes — send us a physical swatch or Pantone code and we will match it in 5–7 days if the shade is not already in our 2,400+ ready-stock catalogue. Minimum lot for custom shades is one bundle (5 thans = ~100 m).",
  },
  {
    q: "Do you export outside India?",
    a:
      "Yes. We ship worldwide via FedEx and DHL. Please share your delivery address on WhatsApp for an accurate freight quote and estimated timeline.",
  },
];

function FAQItem({ item, open, onToggle, idx }) {
  return (
    <div
      className="border-b border-[var(--mp-line)]"
      data-testid={`faq-item-${idx}`}
    >
      <button
        onClick={onToggle}
        className="w-full flex items-center justify-between text-left py-5"
        aria-expanded={open}
        data-testid={`faq-question-${idx}`}
      >
        <span
          className="text-base md:text-lg font-medium pr-4"
          style={{ fontFamily: "'Cormorant Garamond', serif", color: "var(--mp-text)" }}
        >
          {item.q}
        </span>
        <ChevronDown
          className="w-5 h-5 flex-shrink-0 transition-transform"
          style={{
            transform: open ? "rotate(180deg)" : "rotate(0deg)",
            color: "var(--mp-text-strong)",
          }}
        />
      </button>
      {open && (
        <p
          className="pb-5 text-sm leading-relaxed"
          style={{ fontFamily: "'Manrope', sans-serif", color: "var(--mp-muted)" }}
          data-testid={`faq-answer-${idx}`}
        >
          {item.a}
        </p>
      )}
    </div>
  );
}

export default function FAQAccordion() {
  const [openIdx, setOpenIdx] = useState(0);
  return (
    <section className="py-14 lg:py-20" style={{ backgroundColor: "var(--mp-paper)" }} data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-10">
          <p
            className="text-[10px] uppercase tracking-[0.28em] font-semibold mb-3"
            style={{ fontFamily: "'Manrope', sans-serif", color: "var(--mp-copper)" }}
          >
            Questions we get every week
          </p>
          <h2
            className="text-3xl md:text-4xl font-medium tracking-tight"
            style={{ fontFamily: "'Cormorant Garamond', serif", color: "var(--mp-text)" }}
          >
            Frequently Asked Questions
          </h2>
        </div>
        <div className="rounded-sm bg-white border border-[var(--mp-line)] px-6 lg:px-8">
          {FAQS.map((f, i) => (
            <FAQItem
              key={f.q}
              item={f}
              idx={i}
              open={openIdx === i}
              onToggle={() => setOpenIdx(openIdx === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

export { FAQS };
